export type MessageDialogType = 'default' | 'confirm' | 'delete'

export type MessageDialogExposed = {
  show: (
    message: string,
    onOk?: () => void,
    type?: MessageDialogType,
    onCancel?: () => void,
    htmlText?: string,
  ) => void,
  handleCancel: () => void
}

export const useMessageDialog = (): MessageDialogExposed => {
  const nuxtApp = useNuxtApp()
  const dialogRef = nuxtApp.$messageDialog as Ref<ComponentPublicInstance<MessageDialogExposed> | null>

  return {
    show: (message, onOk, type = 'default', onCancel, htmlText) => {
      dialogRef.value?.show(message, onOk, type, onCancel, htmlText)
    },
    handleCancel: () => {
      dialogRef.value?.handleCancel()
    }
  }
}